import Splide from '@splidejs/splide';
export const init = () => {
  if (document.querySelector('.carousel_type-12')) {
    const carousel12 = document.querySelectorAll('.carousel_type-12');
    carousel12.forEach((item) => {
      const splideCarousel12 = new Splide(item, {
        type: 'fade',
        arrows: false,
        autoplay: true,
        pagination: false,
        drag: false,
        interval: 5000,
        rewind: true,
        pauseOnHover: false,
        pauseOnFocus: false,
        breakpoints: {
          1055: {
            drag: true,
            pagination: true,
            autoplay: false,
            classes: {
              pagination: 'splide__pagination g-pagination__type-1',
            },
          }
        }
      },);
      const splideCarousel12Navigation = new Splide(item.nextElementSibling, {
        rewind: true,
        fixedHeight: 137, 
        perPage: 5,
        arrows: false,
        isNavigation: true,   
        pagination: false,              
        dragMinThreshold: {
            mouse: 4,
            touch: 10,
        },
    });
    splideCarousel12.on('autoplay:playing',(rate) => {
      item.nextElementSibling.style.setProperty('--line-width',(rate * 100)+'%');
    });
    splideCarousel12.on('moved',() => {
      if (splideCarousel12.Components.Autoplay.isPaused()) {
        splideCarousel12.Components.Autoplay.play();
      }
    })
    splideCarousel12.on('click',() => {
      if (splideCarousel12.Components.Autoplay.isPaused()) {
        splideCarousel12.Components.Autoplay.play();
      }
      else {
        splideCarousel12.Components.Autoplay.pause();
      }
    })
      splideCarousel12.sync(splideCarousel12Navigation);
      splideCarousel12.mount();
      splideCarousel12Navigation.mount();
    })
  }
}